/**
 * ydl 20190701
 */
var ossUtil = {
  base64toblob: function(dataurl) {
    var arr = dataurl.split(',')
    var mime = arr[0].match(/:(.*?);/)[1]
    var bstr = atob(arr[1])
    var n = bstr.length
    var u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: mime })
  },
  blobtofile: function(blob, filename) {
    blob.lastModifiedDate = new Date()
    blob.name = filename
    return blob
  },
  formatterDate: function(date) {
    var day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
    var month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' +
            (date.getMonth() + 1)
    return date.getFullYear() + '-' + month + '-' + day
  },
  encode: function(input) {
    var output = ''
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4
    var i = 0
    var _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
    input = ossUtil._utf8_encode(input)
    while (i < input.length) {
      chr1 = input.charCodeAt(i++)
      chr2 = input.charCodeAt(i++)
      chr3 = input.charCodeAt(i++)
      enc1 = chr1 >> 2
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
      enc4 = chr3 & 63
      if (isNaN(chr2)) {
        enc3 = enc4 = 64
      } else if (isNaN(chr3)) {
        enc4 = 64
      }
      output = output +
                _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
                _keyStr.charAt(enc3) + _keyStr.charAt(enc4)
    }
    return output
  },
  _utf8_encode: function(string) {
    string = string.replace(/\r\n/g, '\n')
    var utftext = ''
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n)
      if (c < 128) {
        utftext += String.fromCharCode(c)
      } else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192)
        utftext += String.fromCharCode((c & 63) | 128)
      } else {
        utftext += String.fromCharCode((c >> 12) | 224)
        utftext += String.fromCharCode(((c >> 6) & 63) | 128)
        utftext += String.fromCharCode((c & 63) | 128)
      }
    }
    return utftext
  },
  _utf8_decode: function(utftext) {
    var string = ''
    var i = 0
    var c = c1 = c2 = 0
    while (i < utftext.length) {
      c = utftext.charCodeAt(i)
      if (c < 128) {
        string += String.fromCharCode(c)
        i++
      } else if ((c > 191) && (c < 224)) {
        c2 = utftext.charCodeAt(i + 1)
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
        i += 2
      } else {
        c2 = utftext.charCodeAt(i + 1)
        c3 = utftext.charCodeAt(i + 2)
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63))
        i += 3
      }
    }
    return string
  },
  // Bit-wise rotate left
  rotl: function(n, b) {
    return (n << b) | (n >>> (32 - b))
  },

  // Bit-wise rotate right
  rotr: function(n, b) {
    return (n << (32 - b)) | (n >>> b)
  },

  // Swap big-endian to little-endian and vice versa
  endian: function(n) {
    // If number given, swap endian
    if (n.constructor == Number) {
      return ossUtil.rotl(n, 8) & 0x00FF00FF |
                ossUtil.rotl(n, 24) & 0xFF00FF00
    }

    // Else, assume array and swap all items
    for (var i = 0; i < n.length; i++) { n[i] = ossUtil.endian(n[i]) }
    return n
  },

  // Generate an array of any length of random bytes
  randomBytes: function(n) {
    for (var bytes = []; n > 0; n--) { bytes.push(Math.floor(Math.random() * 256)) }
    return bytes
  },

  // Convert a string to a byte array
  stringToBytes: function(str) {
    var bytes = []
    for (var i = 0; i < str.length; i++) { bytes.push(str.charCodeAt(i)) }
    return bytes
  },

  // Convert a byte array to a string
  bytesToString: function(bytes) {
    var str = []
    for (var i = 0; i < bytes.length; i++) { str.push(String.fromCharCode(bytes[i])) }
    return str.join('')
  },

  // Convert a string to big-endian 32-bit words
  stringToWords: function(str) {
    var words = []
    for (var c = 0, b = 0; c < str.length; c++, b += 8) { words[b >>> 5] |= str.charCodeAt(c) << (24 - b % 32) }
    return words
  },

  // Convert a byte array to big-endian 32-bits words
  bytesToWords: function(bytes) {
    var words = []
    for (var i = 0, b = 0; i < bytes.length; i++, b += 8) { words[b >>> 5] |= bytes[i] << (24 - b % 32) }
    return words
  },

  // Convert big-endian 32-bit words to a byte array
  wordsToBytes: function(words) {
    var bytes = []
    for (var b = 0; b < words.length * 32; b += 8) { bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF) }
    return bytes
  },

  // Convert a byte array to a hex string
  bytesToHex: function(bytes) {
    var hex = []
    for (var i = 0; i < bytes.length; i++) {
      hex.push((bytes[i] >>> 4).toString(16))
      hex.push((bytes[i] & 0xF).toString(16))
    }
    return hex.join('')
  },

  // Convert a hex string to a byte array
  hexToBytes: function(hex) {
    var bytes = []
    for (var c = 0; c < hex.length; c += 2) { bytes.push(parseInt(hex.substr(c, 2), 16)) }
    return bytes
  },

  // Convert a byte array to a base-64 string
  bytesToBase64: function(bytes) {
    // Use browser-native function if it exists
    if (typeof btoa === 'function') return btoa(ossUtil.bytesToString(bytes))

    var base64 = []
    var overflow

    for (var i = 0; i < bytes.length; i++) {
      switch (i % 3) {
        case 0:
          base64.push(base64map.charAt(bytes[i] >>> 2))
          overflow = (bytes[i] & 0x3) << 4
          break
        case 1:
          base64.push(base64map.charAt(overflow | (bytes[i] >>> 4)))
          overflow = (bytes[i] & 0xF) << 2
          break
        case 2:
          base64.push(base64map.charAt(overflow | (bytes[i] >>> 6)))
          base64.push(base64map.charAt(bytes[i] & 0x3F))
          overflow = -1
      }
    }

    // Encode overflow bits, if there are any
    if (overflow != undefined && overflow != -1) { base64.push(base64map.charAt(overflow)) }

    // Add padding
    while (base64.length % 4 != 0) base64.push('=')

    return base64.join('')
  },
  random_string(len) {
    len = len || 32
    var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
    var maxPos = chars.length
    var pwd = ''
    for (var i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return pwd
  },
  // Convert a base-64 string to a byte array
  base64ToBytes: function(base64) {
    // Use browser-native function if it exists
    if (typeof atob === 'function') return ossUtil.stringToBytes(atob(base64))

    // Remove non-base-64 characters
    base64 = base64.replace(/[^A-Z0-9+\/]/ig, '')

    var bytes = []

    for (var i = 0; i < base64.length; i++) {
      switch (i % 4) {
        case 1:
          bytes.push((base64map.indexOf(base64.charAt(i - 1)) << 2) |
                        (base64map.indexOf(base64.charAt(i)) >>> 4))
          break
        case 2:
          bytes.push(((base64map.indexOf(base64.charAt(i - 1)) & 0xF) << 4) |
                        (base64map.indexOf(base64.charAt(i)) >>> 2))
          break
        case 3:
          bytes.push(((base64map.indexOf(base64.charAt(i - 1)) & 0x3) << 6) |
                        (base64map.indexOf(base64.charAt(i))))
          break
      }
    }

    return bytes
  },
  HMAC: function(hasher, message, key, options) {
    // Allow arbitrary length keys
    key = key.length > ossUtil._blocksize * 4
      ? hasher(key, { asBytes: true })
      : ossUtil.stringToBytes(key)
    // XOR keys with pad constants
    var okey = key
    var ikey = key.slice(0)
    for (var i = 0; i < ossUtil._blocksize * 4; i++) {
      okey[i] ^= 0x5C
      ikey[i] ^= 0x36
    }
    var hmacbytes = hasher(ossUtil.bytesToString(okey) +
            hasher(ossUtil.bytesToString(ikey) + message, { asString: true }),
    { asBytes: true })
    return options && options.asBytes ? hmacbytes
      : options && options.asString ? ossUtil.bytesToString(hmacbytes)
        : ossUtil.bytesToHex(hmacbytes)
  },
  _sha1: function(message) {
    var m = ossUtil.stringToWords(message)
    var l = message.length * 8
    var w = []
    var H0 = 1732584193
    var H1 = -271733879
    var H2 = -1732584194
    var H3 = 271733878
    var H4 = -1009589776

    // Padding
    m[l >> 5] |= 0x80 << (24 - l % 32)
    m[((l + 64 >>> 9) << 4) + 15] = l

    for (var i = 0; i < m.length; i += 16) {
      var a = H0
      var b = H1
      var c = H2
      var d = H3
      var e = H4

      for (var j = 0; j < 80; j++) {
        if (j < 16) w[j] = m[i + j]
        else {
          var n = w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16]
          w[j] = (n << 1) | (n >>> 31)
        }

        var t = ((H0 << 5) | (H0 >>> 27)) + H4 + (w[j] >>> 0) + (
          j < 20 ? (H1 & H2 | ~H1 & H3) + 1518500249
            : j < 40 ? (H1 ^ H2 ^ H3) + 1859775393
              : j < 60 ? (H1 & H2 | H1 & H3 | H2 & H3) - 1894007588
                : (H1 ^ H2 ^ H3) - 899497514)

        H4 = H3
        H3 = H2
        H2 = (H1 << 30) | (H1 >>> 2)
        H1 = H0
        H0 = t
      }

      H0 += a
      H1 += b
      H2 += c
      H3 += d
      H4 += e
    }
    return [H0, H1, H2, H3, H4]
  },
  _blocksize: 16,
  SHA1: function _blocksize(message, options) {
    var digestbytes = ossUtil.wordsToBytes(ossUtil._sha1(message))
    return options && options.asBytes ? digestbytes
      : options && options.asString ? ossUtil.bytesToString(digestbytes)
        : ossUtil.bytesToHex(digestbytes)
  },
  get_suffix: function(filename) {
    const pos = filename.lastIndexOf('.')
    let suffix = ''
    if (pos != -1) {
      suffix = filename.substring(pos)
    }
    return suffix
  }
}
/**
 * 构造上传实例
 */
var ossUpload = function({ accessid, accesskey, host, dir, maxSize, fileType, complete }) {
  this.accessid = accessid || 'LTAI5TioNc1XRfW2'
  this.accesskey = accesskey || 'EbH9vCWvXEyFlWOUGltUQXPg1gcloF'
  this.host = host || 'https://wangxintong.oss-cn-zhangjiakou.aliyuncs.com'

  this.dir = dir || ''
  this.maxSize = maxSize || 1048576000
  this.fileQueue = []
  // 0---待上传 1---已上传 2---上传出错
  this.fileQueueStatus = []
  this.fileType = fileType
  this.completeFn = complete
}
/**
 * 添加上传文件到上传队列
 * obj file对象 base64字符串 file数组 base64字符串数组
 */
ossUpload.prototype.addFile = function(obj, filename, type) {
  var errMsg = ''
  if (obj instanceof Array) {
    for (var i = 0; i < obj.length; i++) {
      var res = this.addFileQueue(obj[i], filename[i], (type ? type[i] : 'noNaming'))
      if (res.success == false) {
        errMsg += res.errMsg
      }
    }
  } else if (obj) {
    var res = this.addFileQueue(obj, filename, type || 'noNaming')
    if (res.success == false) {
      errMsg += res.errMsg
    }
  } else {
    console.error('obj is not file fileArray base64 base64Array')
    errMsg += 'obj is not file fileArray base64 base64Array'
  }
  if (errMsg !== '') {
    return {
      success: false,
      errMsg: errMsg
    }
  } else {
    return {
      success: true
    }
  }
}
/**
 * base64字符串转文件对象
 */
ossUpload.prototype.addFileQueue = function(obj, name, type) {
  var _file
  var _name
  if (typeof (obj) === 'object') {
    // push file
    _file = obj
    _name = name
  } else {
    // push base64 file
    _file = ossUtil.blobtofile(ossUtil.base64toblob(obj), name)
    _name = name
  }
  if (_file.size < this.maxSize && this.fileType.indexOf(ossUtil.get_suffix(_file.name)) !== -1) {
    var nowDate = new Date()
    var year = nowDate.getFullYear().toString()
    var month = (nowDate.getMonth() + 1 < 10 ? '0' + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1).toString()
    var day = (nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()).toString()
    var dateStr = year + month + day // 获取当前日期 生成文件夹
    this.fileQueue.push({
      file: _file,
      name: _name,
      name_prefix: this.dir + (this.dir ? '/' : '') + (type == 'noNaming' ? (dateStr + '/' + new Date().getTime() + '_' + ossUtil.random_string(32) + '_') : '')
    })
    // name_prefix 拼凑的逻辑是 如果图片类型为不需要命名 则生成当日日期文件夹 随机文件名存入，如果需要命名 则不需要生成日期文件夹 直接按照传入的名字存储
    this.fileQueueStatus.push(0)
    return {
      success: true
    }
  } else {
    return {
      suceess: false,
      errMsg: name + '文件非法类型或大小不对'
    }
  }
}
ossUpload.prototype.uploadComplete = function() {
  var _result = []
  // 处理返回结果
  for (var i = 0; i < this.fileQueueStatus.length; i++) {
    var _success = this.fileQueueStatus[i] === 1 ? 1 : 0
    _result.push({
      local_name: this.fileQueue[i]['name'],
      success: _success,
      web_path: _success ? (this.host + '/' + this.fileQueue[i]['name_prefix'] + this.fileQueue[i]['name']) : ''
    })
  }
  this.completeFn(_result)
  // 清理未成功的结果。
  var _unsuccess_index = []
  this.fileQueueStatus.map(function(m, index) {
    if (m === 2) {
      _unsuccess_index.push(index)
    }
  })
  this.fileQueueStatus = new Array(_unsuccess_index.length).fill(0)
  this.fileQueue = this.fileQueue.filter(function(m, index) { return _unsuccess_index.indexOf(index) !== -1 })
}
ossUpload.prototype.sendCallback = function(req, index) {
  console.log(req)
  if (req.readyState == 4 && req.status == 200) {
    var b = req.responseText
    // 某个文件上传成功
    this.fileQueueStatus[index] = 1
  }
  if (req.readyState == 4 && req.status !== 200) {
    // 某个文件上传失败
    this.fileQueueStatus[index] = 2
  }
  if (req.readyState == 4) {
    if (this.fileQueueStatus.filter(function(m) { return m === 0 }).length == 0) {
      // 所有上传任务都有结果
      this.uploadComplete()
    }
  }
}
ossUpload.prototype.start = function() {
  var curr_timestamp = new Date().getTime()
  var expire_day = ossUtil.formatterDate(new Date(curr_timestamp + 2000 * 60 * 60 * 24))
  // 开始上传
  var policyText = {
    'expiration': expire_day + 'T12:00:00.000Z', // 设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
    'conditions': [
      ['content-length-range', 0, this.maxSize] // 设置上传文件的大小限制
    ]
  }
  this.policyBase64 = ossUtil.encode(JSON.stringify(policyText))
  var bytes = ossUtil.HMAC(ossUtil.SHA1, this.policyBase64, this.accesskey, { asBytes: true })
  this.signature = ossUtil.bytesToBase64(bytes)
  // without key and name whitch refers to the filename
  this.token = {
    policy: this.policyBase64,
    OSSAccessKeyId: this.accessid,
    signature: this.signature,
    success_action_status: 200
  }
  for (var i = 0; i < this.fileQueue.length; i++) {
    console.log(this.fileQueue[i]['file'], '------上传前')
    // 上传队列里面的每张图片
    var name = this.fileQueue[i]['name_prefix'] + this.fileQueue[i]['name']
    var file = this.fileQueue[i]['file']
    var form = new FormData()
    form.append('signature', this.token.signature)
    form.append('OSSAccessKeyId', this.token.OSSAccessKeyId)
    form.append('policy', this.token.policy)
    form.append('success_action_status', 200)
    form.append('key', name)
    form.append('file', file)
    form.append('name', name)
    const req = new XMLHttpRequest()
    req.onreadystatechange = this.sendCallback.bind(this, req, i)
    req.open('post', this.host, false)
    req.send(form)
  }
}
export default ossUpload
